var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterDesktopStreamReply = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13.861 5.925q0-2.01-1.388-3.39-1.388-1.378-3.398-1.378l-3.15-.018q-2.01 0-3.398 1.388T1.139 5.89q0 1.974 1.361 3.238 1.36 1.263 3.443 1.263h.303q.23 0 .4.17a.55.55 0 0 1 .169.4v2.42q4.27-2.794 5.151-3.541a5.45 5.45 0 0 0 1.388-1.788 4.8 4.8 0 0 0 .507-2.127m1.139 0v.018a5.9 5.9 0 0 1-.614 2.598q-.614 1.263-1.833 2.295t-6.005 4.075a.7.7 0 0 1-.383.089.4.4 0 0 1-.364-.205.7.7 0 0 1-.125-.364v-2.9Q3.24 11.44 1.62 9.848T0 5.845q0-2.41 1.717-4.128T5.925 0l3.15.018q2.49 0 4.208 1.708Q15 3.435 15 5.926"
})));
export default SvgTwitterDesktopStreamReply;